import { useBrand } from '@/contexts/BrandContext';
import { MessageSquare } from 'lucide-react';

export function PortalFooter() {
  const { brand } = useBrand();

  return (
    <footer className="border-t mt-auto">
      <div className="mx-auto max-w-[1120px] px-4 md:px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {brand?.contact_email && (
            <div className="flex items-center gap-4">
              <a
                href={`mailto:${brand.contact_email}`}
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                <MessageSquare className="h-4 w-4" />
                Contact support
              </a>
            </div>
          )}
          <div className="text-sm text-muted-foreground">
            {brand?.name ? `© ${new Date().getFullYear()} ${brand.name}` : ''}
          </div>
        </div>
      </div>
    </footer>
  );
}
